import { SideNavProvider } from './SideNavProvider';
import { SideNavHeader } from './SideNavHeader';
import { SideNavLinkProvider } from './SideNavLinkProvider';

SideNavProvider.Header = SideNavHeader;
SideNavProvider.Link = SideNavLinkProvider;

export { SideNavProvider };
